import { RESET_FORM } from '../actionTypes';
import { privateDocumentsActions } from '../reducer';

export default () => privateDocumentsActions[RESET_FORM]();
